<template>
  <Grid class="grid-nogutter">
    <Col12>
      <div
        class="single-column-layout"
        :class="[fullViewport ? 'full-viewport' : 'default', { 'no-padding-top': noPaddingTop }]"
      >
        <Card
          id="main-content-card"
          class="layout-card max-w-[var(--breakpoint-xl)] mx-auto"
          :class="cardClasses"
        >
          <template #header v-if="$slots?.header">
            <div class="header">
              <slot name="header" />
            </div>
          </template>

          <template #content>
            <div class="content">
              <template v-if="loading">
                <Grid>
                  <Col12>
                    <Skeleton width="70%" class="mb-2" />
                    <Skeleton />
                  </Col12>
                  <Col12>
                    <Skeleton width="70%" class="mb-2" />
                    <Skeleton />
                  </Col12>
                  <Col12>
                    <Skeleton width="70%" class="mb-2" />
                    <Skeleton />
                  </Col12>
                  <Col12>
                    <Skeleton width="70%" class="mb-2" />
                    <Skeleton />
                  </Col12>
                </Grid>
              </template>

              <template v-else>
                <slot name="content" />
              </template>
            </div>
          </template>
        </Card>
      </div>
    </Col12>
  </Grid>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Card, CardHelperClasses } from '../../containers';
import { Skeleton } from '../../misc';
import { Col12 } from '../columns';
import { Grid } from '../grids';
import { useContentPageStore } from '@centric-os/stores/content-page/use-content-page-store';
import { storeToRefs } from 'pinia';

// Define options for component name
defineOptions({
  name: 'SingleColumnLayout',
});

// Define props
const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  fullViewport: {
    type: Boolean,
    default: false,
  },
  removeBackground: {
    type: Boolean,
    default: false,
  },
  noPaddingTop: {
    type: Boolean,
    default: false,
  },
});

// Set content page store for heigh calculation
const contentPageStore = useContentPageStore();
const { contentPageLayoutHeight } = storeToRefs(contentPageStore);

// Computed for card classes
const cardClasses = computed<string[]>(() => {
  const classes = [CardHelperClasses.NO_SHADOWS];

  if (props.removeBackground) {
    classes.push(CardHelperClasses.NO_BACKGROUND);
  }
  return classes;
});
</script>

<style lang="scss" scoped>
.single-column-layout {
  padding-top: 2rem;
  background-color: var(--neutral-light-color);

  &.no-padding-top {
    padding-top: 0;
  }

  &.full-viewport {
    height: v-bind('contentPageLayoutHeight');
    max-height: v-bind('contentPageLayoutHeight');

    .default {
      max-height: v-bind('contentPageLayoutHeight');
    }
  }
}
</style>
